import Bdms from './Bdms';
import BdmsFragment from './BdmsFragment';
import { validationHelper } from '../../../util/validation';
import { isRelatedObjectDefined, prepareDisposalForSave } from '../../../util/bookable';
import { flattenBookingItems } from '../../../util/products';
import { flattenStaffAllocations } from '../../../util/functions';

export default {
    label: 'BDMs',
    component: Bdms,
    fragment: BdmsFragment,
    onLoad: data => {
        if (data.Disposal) {
            flattenBookingItems(data.Disposal, 'DisposalBookingItems');
            data.Disposal.DisposalBookingItems = (data.Disposal.DisposalBookingItems || []).filter(x =>
                isRelatedObjectDefined(x)
            );
            flattenStaffAllocations(data.Disposal);
        }
    },
    formatSaveData: (saveData, state, original) => {
        // don't write any of this data, it is generated in php
        [
            'FuneralDataStatus',
            'ExportDate',
            'ExportStatus',
            'ExportId',
            'DeathCertificateStatus',
            'DeathCertificateNumber',
            'FormattedBDMResponse',
            'LifeLinkValidationField',
            'WebServiceLogs',
            'BdmResponse'
        ].forEach(e => {
            delete saveData[e];
        });

        if (!!saveData.Application && !!saveData.Application.Quantity) {
            saveData.Application.Quantity = Number(saveData.Application.Quantity);
        }

        if (saveData.LegacyDocuments) {
            saveData.LegacyDocuments = saveData.LegacyDocuments.map(({ ID }) => ({ ID }));
        }
        if (saveData.Disposal) {
            prepareDisposalForSave(saveData, state, original);
        }
    },

    validation: {
        onValidate: {
            'Application.Quantity': (newValue, persistedValue, hasValue, getField) => {
                if (!getField('Application.CertificateRequired')) return validationHelper.ok();
                const quantity = parseInt(persistedValue, 10);
                if (quantity > 0 && !isNaN(quantity)) return validationHelper.ok();
                return validationHelper.required('Must be at least 1');
            },
            CertificateRequired: (newValue, persistedValue, hasValue, getField) => {
                const notRequired = getField('DeathCertificateNotRequired');
                const isRequired = getField('Application.CertificateRequired');
                return notRequired || isRequired ? validationHelper.ok() : validationHelper.suggested();
            }
        }
    }
};
